import { makeStyles, Typography } from "@material-ui/core"
import React from "react"

const useStyles = makeStyles(theme => ({
    container: {
        position: "relative",
        width: "100%",
        boxShadow: "0 8px 40px rgba(0,0,0,.35)",
        color: "#111",
        overflow: "hidden",
        padding: 0,
        [theme.breakpoints.down("sm")]: {
            width: "100vw",
            height: "100dvh",
            borderRadius: 0,
        },
        [theme.breakpoints.up("md")]: {
            maxWidth: "400px",
            aspectRatio: "9/16",
            margin: "0 auto",
        },
    },
    content: {
        position: "relative",
        height: "100%",
        width: "100%",
        padding: "clamp(16px, 4vw, 24px)",
        display: "flex",
        flexDirection: "column",
        backgroundSize: "cover",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        [theme.breakpoints.down("sm")]: {
            backgroundSize: "100% 100%",
            backgroundPosition: "center center",
        },
    },
    ContainerInstaClienteFiel: {
        position: "relative",
        bottom: "3rem",
        textAlign: "center",
    },
    instaClienteFiel: {
        color: "white",
        fontWeight: "bold",
        textShadow: "0px 10px 28px rgba(0,0,0,.6)",
    },
}))

type Props = {
    children: React.ReactNode
    img: string
    gradiente: string
}

export function ContainerInsta({ children, img, gradiente }: Props) {
    const classes = useStyles()

    return (
        <div className={classes.container}>
            <div
                className={classes.content}
                style={{
                    backgroundImage: img
                        ? [`url("data:image/svg+xml,${img}")`, `${gradiente}`].join(", ")
                        : gradiente
                        ? [`${gradiente}`].join(", ")
                        : "none",
                    backgroundBlendMode: img ? "overlay, normal" : "normal",
                }}
            >
                {children}
            </div>
            <div className={classes.ContainerInstaClienteFiel}>
                <Typography className={classes.instaClienteFiel}>@clientefiel</Typography>
            </div>
        </div>
    )
}
